import React from 'react';
import InformationCircleIcon from '@heroicons/react/outline/InformationCircleIcon.js';
import { SpaceType } from '@tribeplatform/gql-client/types';
import { BlockType } from '../../types/index.js';
import { SpaceAboutBlock as Component } from './Block.js';
import { SpaceAboutBlockSettings as Settings } from './Settings.js';
export const RegisteredSpaceAboutBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'SpaceAbout',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            availabilityConditions: {
                spaceType: SpaceType.Group,
            },
            displayName: $t({
                id: 'Blocks.SpaceAbout.DisplayName',
                defaultMessage: 'About',
            }),
            Settings,
            defaultProps: {
                title: $t({
                    id: 'Blocks.SpaceAbout.DisplayName',
                    defaultMessage: 'About',
                }),
                showMembersCount: true,
                showPostsCount: true,
                showCreationDate: true,
            },
            Icon: React.createElement(InformationCircleIcon, null),
        },
    };
};
//# sourceMappingURL=registered.js.map